module.exports = __webpack_public_path__ + "img/frontSin.c6c3531c.webp";